import React from 'react';

const ProfileContext = React.createContext<null | Object>(null);

export default ProfileContext;
